module.exports = __webpack_public_path__ + "img/success.a065bc09.svg";